import LazyImage from "./LazyImage";
import { Box, Button, Divider, Stack, Typography } from "@mui/material";
import hero from "../assets/images/ramadanHero.png";
// import heroPlaceholder from "../assets/images/hero-placeholder.png";
import MenuButton from "./layout/MenuButton";
import useAuth from "../hooks/useAuth";
import { useNavigate } from "react-router-dom";
import zain from "../assets/images/zain-logo.svg";
import Searchbar from "./layout/Searchbar";
import { subscribe } from "../config/axios";
// import { TypeAnimation } from "react-type-animation";

export default function Banner() {
  const { token } = useAuth();
  const navigate = useNavigate();

  return (
    <Box
      position="relative"
      height={{ xs: "60vh", md: "70vh" }}
      minHeight="300px"
      maxWidth="100%"
    >
      <LazyImage src={hero} />
      <Stack
        position="absolute"
        top={1}
        right={0}
        height={{ xs: "95%", md: "90%" }}
        width={{ xs: "100%", md: "95%" }}
        flexDirection="column"
        alignItems="flex-start"
        justifyContent="space-between"
      >
        <Stack
          flexDirection="row"
          justifyContent="space-between"
          width="100%"
          mt={1}
        >
          <MenuButton />
          <img
            src={zain}
            alt=""
            style={{
              height: "4rem",
              width: "auto",
              borderRadius: "0.3em",
              marginInline: "8px",
              objectFit: "cover",
            }}
          />
        </Stack>
        <Stack mx={2} mb={1}>
          <Typography
            variant="h2"
            fontWeight={700}
            color="white"
            sx={{
              textShadow: "0 0 0.05em slategray",
            }}
          >
            قانوني
          </Typography>

          <Divider width="50rem" sx={{ bgcolor: "white", mt: 2, mb: 2 }} />
          <Typography
            variant="h4"
            fontWeight={400}
            color="white"
            sx={{
              textShadow: "0 0 0.05em slategray",
            }}
          >
            كل ما تحتاجه من إستشارات
          </Typography>
          <Typography
            variant="h4"
            fontWeight={400}
            color="white"
            sx={{
              textShadow: "0 0 0.05em slategray",
            }}
          >
            قانونية الان في متناول يدك
          </Typography>

          {/* <TypeAnimation
            sequence={[
              "كل ما تحتاجه من إستشارات قانونية الان في  متناول يدك",
              1000,
              "",
            ]}
            speed={50}
            wrapper="h2"
            repeat={Infinity}
            style={{
              maxWidth: "280px",
              minHeight: "96px",
              textShadow: "0 0 0.05em slategray",
              color: "white",
              fontWeight: 400,
              fontSize: "1.7rem",
              fontFamily: "neo-sans",
            }}
          /> */}

          <Searchbar
            sx={{
              display: { xs: "none", md: "inherit" },
              mt: 3,
              "& .MuiInputBase-root": { backgroundColor: "white" },
              width: "280px",
            }}
          />

          {!token && (
            <Stack
              flexDirection="row"
              justifyContent="flex-start"
              gap={2}
              mt={3}
            >
              <a href={subscribe} style={{ textDecoration: "none" }}>
                <Button
                  size="small"
                  variant="contained"
                  // onClick={() => navigate("/subscribe")}
                  sx={{ minWidth: "110px", px: 1 }}
                >
                  الإشتراك
                </Button>
              </a>
              <Button
                size="small"
                variant="contained"
                color="btnwhite"
                // fullWidth

                sx={{
                  color: (theme) => theme.palette.primary.main,
                  whiteSpace: "nowrap",
                  px: 1,
                  minWidth: "110px",
                }}
                onClick={() => navigate("/login")}
              >
                تسجيل الدخول
              </Button>
            </Stack>
          )}
        </Stack>
      </Stack>
    </Box>
  );
}
